import React from "react";

import { Column } from "commons/types/table";

export type TableBodyContextType<T> = {
    dataLength: number;
    columns: Array<Column<T>>;
};

export const TableBodyContext = React.createContext<TableBodyContextType<any>>({
    dataLength: 0,
    columns: [],
});

export const useTableBodyContext = <T,>() =>
    React.useContext<TableBodyContextType<T>>(TableBodyContext);
